import { Column } from 'app/design/primitives/box';
import React from 'react';
import { theme } from './shared';
import { PlaceListings } from './place-listings';
import { NeighbourListings } from './neighbour-listings';

export function ProfileListings({
  isPlace,
  neighbour,
  place,
}: {
  isPlace: boolean;
  neighbour: React.ComponentProps<typeof NeighbourListings>;
  place: React.ComponentProps<typeof PlaceListings>;
}) {
  return (
    <Column
      style={{
        paddingBottom: theme.spacing['spacing.general.x4'],
        backgroundColor: theme.colors['surface.default'],
      }}
    >
      {isPlace ? <PlaceListings {...place} /> : <NeighbourListings {...neighbour} />}
    </Column>
  );
}
